import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getTrialBalances = ({ churchId, startDate, endDate }) => {
  return axios.get(
    `/churches/${churchId}/trial-balance?start_date=${startDate}&end_date=${endDate}&sort[account_type]=desc`
  );
};

export const useTrialBalances = ({
  churchId,
  startDate,
  endDate,
  config
} = {}) => {
  return useQuery({
    ...config,
    queryKey: ["trial-balances", churchId, startDate, endDate],
    queryFn: () => getTrialBalances({ churchId, startDate, endDate }),
    select: data => data.result
  });
};
